import React, { useContext } from 'react';
import Slider from "react-slick";

import Logo from "../../assets/img/brand-logo.svg";
import LogoKa from "../../assets/img/brand-logo-ka.svg";
import ArrowDown from "../../assets/img/arrow-down.svg";
import baner4 from "../../assets/img/slider/banner4.jpg";
import baner5 from "../../assets/img/slider/banner5.jpg";
import baner6 from "../../assets/img/slider/banner6.jpg";
import "./style.css";
import { Context } from '../../context/Products';

const Header = ({ promoText }) => {
    const [{ lang }] = useContext(Context);
    const activeLogo = lang === "ka" ? LogoKa : Logo;

    const settings = {
        draggable: false,
        arrows: false,
        dots: false,
        fade: true,
        speed: 2000,
        infinite: true,
        cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
        autoplay: true,
        autoplaySpeed: 4000,
        pauseOnHover: false
    };

    const handleClick = () => {
        const pageHeight = window.innerHeight;
        window.scrollTo({top: pageHeight, left: 0, behavior: 'smooth'})
    };

    return (
        <header id="main" className="scroll-fullpage" data-hash="a">
            <img src={activeLogo} alt={lang === "ka" ? "კაპიტანი ქენდი" : "Captain Candy"} id="brand-logo" />
            <img src={ArrowDown} alt="more" id="arrow-down" onClick={() => handleClick()} />
            <h1 id="motto-main">
                <span id="promo1" className="hidden-xs hidden-sm hidden-sm-plus" style={{ display: "block" }}>
                    · {promoText?.text} ·
                </span>
                <div className="visible-xs">
                    <img src={promoText?.promoTextXs} alt={promoText?.text} id="promo-xs" />
                </div>
                <div className="visible-sm visible-sm-plus">
                    <img src={promoText?.promoText} alt={promoText?.text} id="promo-sm" /> 
                </div>
            </h1>
            <div className="slideshow">
                <Slider {...settings}>
                    <div className="item"><img src={baner6} srcSet={baner6} alt="Captain Candy Georgia interior" /></div>
                    <div className="item"><img src={baner5} srcSet={baner5} alt="Captain Candy barrels and sweets" /></div>
                    <div className="item"><img src={baner4} srcSet={baner4} alt="Captain Candy Georgia store" /></div>
                </Slider>
            </div>
        </header>
    )
};

export default Header;
